/* ============================================================================
   Deal Basket — visual effects (moved out of layout/theme.liquid so the browser
   can cache them). Purely visual: cart and wishlist logic live in theme.js.
   1. Fly-to-cart image when an add-to-cart button is pressed
      (product page button, card "+" buttons, and the colour/size pop-up)
   2. Heart burst when a product is added to the wishlist
   Loaded with `defer` BEFORE theme.js initialises, so the wishlist listener still
   reads the count before theme.js updates it (same order as before).
   ========================================================================== */
/* One tap = one item: extra taps on the same "Add to cart" button within 1.2 s are
   ignored, so a quick double/triple tap can't add 2-3 pieces by mistake. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-add]');
    if (!btn) { return; }
    var now = Date.now();
    var last = parseInt(btn.getAttribute('data-db-last-tap'), 10) || 0;
    if (now - last < 1200) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    btn.setAttribute('data-db-last-tap', String(now));
  }, true);
})();

(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
(function(){
    var CART_ICON_SELECTOR = '[data-testid="nav-cart"], [data-testid="bnav-cart"]';
    var CART_COUNT_SELECTOR = '[data-cart-count]';
  
    function findCartIcon(){
      /* header cart on desktop, bottom-bar cart on phones — use the one on screen */
      var els = document.querySelectorAll(CART_ICON_SELECTOR);
      for (var i = 0; i < els.length; i++) { var r = els[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return els[i]; }
      return els[0] || null;
    }
  
    function findProductImage(button){
      // Collection / grid page quick-add button
      if (button.matches('[data-quick-add]')){
        var card = button.closest('[data-testid^="product-card-"]');
        if (card) {
          var img = card.querySelector('img');
          if (img) return img;
        }
      }
      // Product detail page add-to-cart button
      if (button.matches('[data-add-to-cart]')){
        var mainImg = document.querySelector('[data-gallery-main]');
        if (mainImg) return mainImg;
      }
      // fallback: nearest img up the tree
      var el = button;
      while (el && el !== document.body){
        var found = el.querySelector ? el.querySelector('img') : null;
        if (found) return found;
        el = el.parentElement;
      }
      return null;
    }
  
    function flyToCart(imgEl){
      var cartIcon = findCartIcon();
      if (!imgEl || !cartIcon) return;
  
      var startRect = imgEl.getBoundingClientRect();
      var endRect = cartIcon.getBoundingClientRect();
      var size = 56;
  
      var clone = document.createElement('img');
      clone.src = imgEl.currentSrc || imgEl.src;
      clone.className = 'ftc-flying-item';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = (startRect.left + startRect.width/2 - size/2) + 'px';
      clone.style.top = (startRect.top + startRect.height/2 - size/2) + 'px';
      document.body.appendChild(clone);
  
      var startX = startRect.left + startRect.width/2 - size/2;
      var startY = startRect.top + startRect.height/2 - size/2;
      var endX = endRect.left + endRect.width/2 - size/2;
      var endY = endRect.top + endRect.height/2 - size/2;
  
      var dx = endX - startX;
      var dy = endY - startY;
      var dist = Math.hypot(dx, dy) || 1;
      var perpX = -dy / dist;
      var perpY = dx / dist;
      var zig = Math.max(40, dist * 0.16);
  
      var waypoints = [
        { t: 0.00, side: 0,    lift: 0   },
        { t: 0.18, side:  1,   lift: -70 },
        { t: 0.38, side: -1.1, lift: -40 },
        { t: 0.58, side:  1.1, lift: -55 },
        { t: 0.78, side: -0.8, lift: -20 },
        { t: 1.00, side: 0,    lift: 0   }
      ];
  
      var keyframes = waypoints.map(function(wp){
        var baseX = startX + dx * wp.t;
        var baseY = startY + dy * wp.t;
        var x = baseX + perpX * zig * wp.side;
        var y = baseY + perpY * zig * wp.side + wp.lift;
        var scale = 1 - 0.78 * wp.t;
        var rotate = wp.side * 18 * (1 - wp.t);
        var opacity = wp.t < 0.85 ? 1 : 1 - (wp.t - 0.85) / 0.15 * 0.7;
        return {
          transform: 'translate(' + (x - startX) + 'px, ' + (y - startY) + 'px) scale(' + scale + ') rotate(' + rotate + 'deg)',
          opacity: opacity,
          offset: wp.t
        };
      });
  
      var anim = clone.animate(keyframes, {
        duration: 950,
        easing: 'cubic-bezier(.45,.05,.55,.95)'
      });
  
      anim.onfinish = function(){
        clone.remove();
        cartIcon.classList.remove('ftc-cart-shake');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('ftc-cart-shake');
  
        var countEl = document.querySelector(CART_COUNT_SELECTOR);
        if (countEl){
          countEl.classList.remove('ftc-cart-bump');
          void countEl.offsetWidth;
          countEl.classList.add('ftc-cart-bump');
        }
      };
    }
    window.dbFlyToCart = flyToCart;
  
    document.addEventListener('click', function(e){
      /* card "+" (snippets/db-quick-plus.liquid) — only for products that add in one tap;
         products with colour / size fly when Add to cart is pressed in the pop-up */
      var plus = e.target.closest('[data-db-plus-add]');
      if (plus) {
        var wrap = plus.closest('[data-db-plus]');
        if (!wrap || wrap.getAttribute('data-multi') === 'true' || wrap.getAttribute('aria-busy') === 'true') return;
        var card = wrap.closest('[data-testid^="product-card-"]');
        var cardImg = card && card.querySelector('img');
        if (cardImg) flyToCart(cardImg);
        return;
      }

      /* colour / size pop-up — fly only when a full choice is made and it is in stock */
      var sheetAdd = e.target.closest('[data-sheet-add]');
      if (sheetAdd) {
        var sheet = sheetAdd.closest('.db-sheet');
        if (!sheet || sheetAdd.disabled || /sold out/i.test(sheetAdd.textContent)) return;
        var picks = sheet.querySelectorAll('.db-sheet__lbl span');
        for (var i = 0; i < picks.length; i++) { if (picks[i].textContent === 'select one') return; }
        var sheetImg = sheet.querySelector('.db-sheet__img');
        if (sheetImg) flyToCart(sheetImg);
        return;
      }

      var btn = e.target.closest('[data-quick-add], [data-add-to-cart]');
      if (!btn) return;
      if (btn.classList.contains('db-in-cart')) return;   /* "Go to cart" only opens the cart */
      var img = findProductImage(btn);
      if (img) flyToCart(img);
      // preventDefault nahi kar rahe — aapki asli add-to-cart JS (fetch/AJAX)
      // bilkul normal chalti rahegi, ye sirf visual effect hai.
    }, true);
  })();
  
(function(){
    var WISHLIST_ICON_SELECTOR = '[data-testid="nav-wishlist"], [data-testid="bnav-wishlist"]';
    var WISHLIST_COUNT_SELECTOR = '[data-wishlist-count]';
  
    function flyHeartToIcon(){
      var wishlistIcon = null;
      var wEls = document.querySelectorAll(WISHLIST_ICON_SELECTOR);
      for (var wi = 0; wi < wEls.length; wi++) { var wr = wEls[wi].getBoundingClientRect(); if (wr.width > 0 && wr.height > 0) { wishlistIcon = wEls[wi]; break; } }
      if (!wishlistIcon) return;
  
      var endRect = wishlistIcon.getBoundingClientRect();
      var size = 24;
      var startX = window.innerWidth/2 - size/2;
      var startY = window.innerHeight*0.35 - size/2;
      var endX = endRect.left + endRect.width/2 - size/2;
      var endY = endRect.top + endRect.height/2 - size/2;
  
      var fly = document.createElement('div');
      fly.className = 'wtc-fly-heart';
      fly.textContent = '\u2764\ufe0f';
      fly.style.left = startX + 'px';
      fly.style.top = startY + 'px';
      document.body.appendChild(fly);
  
      var dx = endX - startX;
      var dy = endY - startY;
      var dist = Math.hypot(dx, dy) || 1;
      var perpX = -dy / dist;
      var perpY = dx / dist;
      var zig = Math.max(30, dist * 0.18);
  
      var waypoints = [
        { t: 0.00, side: 0,    lift: 0   },
        { t: 0.25, side: 1,    lift: -30 },
        { t: 0.55, side: -1,   lift: -15 },
        { t: 0.80, side: 0.6,  lift: -5  },
        { t: 1.00, side: 0,    lift: 0   }
      ];
  
      var keyframes = waypoints.map(function(wp){
        var baseX = dx * wp.t;
        var baseY = dy * wp.t;
        var x = baseX + perpX * zig * wp.side;
        var y = baseY + perpY * zig * wp.side + wp.lift;
        var scale = 1 - 0.6 * wp.t;
        var rotate = wp.side * 20 * (1 - wp.t);
        return {
          transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ') rotate(' + rotate + 'deg)',
          offset: wp.t
        };
      });
  
      var anim = fly.animate(keyframes, { duration: 750, easing: 'cubic-bezier(.45,.05,.55,.95)' });
      anim.onfinish = function(){
        fly.remove();
        wishlistIcon.classList.remove('wtc-wish-shake');
        void wishlistIcon.offsetWidth;
        wishlistIcon.classList.add('wtc-wish-shake');
  
        var countEl = document.querySelector(WISHLIST_COUNT_SELECTOR);
        if (countEl){
          countEl.classList.remove('wtc-wish-bump');
          void countEl.offsetWidth;
          countEl.classList.add('wtc-wish-bump');
        }
      };
    }
  
    function playBurst(){
      var burst = document.createElement('div');
      burst.className = 'wtc-burst-heart';
      burst.textContent = '\u2764\ufe0f';
      burst.style.left = (window.innerWidth/2 - 32) + 'px';
      burst.style.top = (window.innerHeight*0.35 - 32) + 'px';
      document.body.appendChild(burst);
  
      var burstAnim = burst.animate([
        { transform: 'scale(0.3)', opacity: 0, offset: 0 },
        { transform: 'scale(1.3)', opacity: 1, offset: 0.35 },
        { transform: 'scale(1)',   opacity: 1, offset: 0.55 },
        { transform: 'scale(0.8)', opacity: 0.9, offset: 0.75 }
      ], { duration: 550, easing: 'cubic-bezier(.17,.89,.32,1.49)', fill: 'forwards' });
  
      burstAnim.onfinish = function(){
        burst.remove();
        flyHeartToIcon();
      };
    }
  
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
  
      var countEl = document.querySelector(WISHLIST_COUNT_SELECTOR);
      var beforeCount = countEl ? (parseInt(countEl.textContent || '0', 10) || 0) : 0;
  
      setTimeout(function(){
        var afterCount = countEl ? (parseInt(countEl.textContent || '0', 10) || 0) : 0;
        if (afterCount > beforeCount) {
          playBurst();
        }
        // agar count kam hua ya same raha (remove ya error), animation nahi chalega
      }, 120);
    }, false);
  })();
  
})();
